import styled, { css } from 'styled-components';
import { Spinner } from '@lmn/design-system';
import { focusRing } from '@/app/components/search/styles/mixins.ts';

export const Cta = styled.button<{ isClear?: boolean; isActive?: boolean; isDisabled?: boolean }>`
  background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundBrandPrimary};
  color: #fff;
  height: 40px;
  line-height: 40px;
  font-size: ${({ theme }) => theme.kallisto.font.size['175']};
  font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
  border-radius: 6px;
  min-width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${({ isClear }) =>
    !isClear &&
    css`
      padding: 10px 16px;
    `}

  ${({ isClear }) =>
    isClear &&
    css`
      background-color: #fff;
      color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    `}

  ${({ isClear, isDisabled }) =>
    isClear &&
    isDisabled &&
    css`
      background-color: #fff;
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      cursor: default;
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      color: ${({ theme }) => theme.kallisto.color.text.interactive.textPrimaryDefault};
    `}

  ${({ isClear, isDisabled }) =>
    !isClear &&
    isDisabled &&
    css`
      background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
      border-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
      color: ${({ theme }) => theme.kallisto.color.common.black[200]};
      cursor: default;
    `}
`;

export const CtaV2 = styled(Cta)<{ hasMinWidth?: boolean; isBold?: boolean }>`
  position: relative;
  height: 48px;
  line-height: 24px;
  padding: 12px 16px;
  border: none;
  border-radius: 8px;
  font-size: 16px;

  ${({ hasMinWidth, isClear }) =>
    hasMinWidth
      ? css`
          max-width: 100%;
        `
      : // Clear hugs its label; apply keeps Cta's floor so a spinner-only CTA holds its shape.
        isClear &&
        css`
          min-width: unset;
        `}

  ${({ theme, isBold }) =>
    isBold
      ? css`
          font-weight: ${theme.kallisto.font.weight.bold};
        `
      : css`
          font-weight: ${theme.kallisto.font.weight.medium};
        `}

  ${({ isClear }) =>
    isClear &&
    css`
      background-color: transparent;
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      border-color: ${({ theme }) => theme.kallisto.color.border.static.borderDisabled};
      color: ${({ theme }) => theme.kallisto.color.text.static.textDisabled};
      cursor: default;
    `}

  ${({ isClear, isDisabled }) =>
    !isClear &&
    isDisabled &&
    css`
      background-color: ${({ theme }) => theme.kallisto.color.background.static.backgroundDisabled};
    `}

  &:focus-visible {
    ${focusRing};
  }
`;

// Centred by auto margins, not a transform: the spinner animates its own transform.
export const CtaSpinner = styled(Spinner)`
  position: absolute;
  inset: 0;
  margin: auto;
`;

// Hidden rather than unmounted, so the CTA keeps the width of its label while the spinner shows.
export const CtaLabel = styled.span<{ $hidden?: boolean }>`
  visibility: ${({ $hidden }) => ($hidden ? 'hidden' : 'visible')};
`;
